module.exports = __webpack_public_path__ + "img/placeholder/gallery/chemical-brothers-marcus-lyall-adam-smith-showjpg.jpg";